import { QueryClient, QueryClientProvider } from "react-query";

import { SimpleProductTeaser as UISimpleProdutTeaser } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/SimpleProductTeaser/SimpleProductTeaser";
import { useProductsDynamicData } from "@jti/ui/hooks/useEssentialProductData/useEssentialProductData";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { Placeholder } from "@/components/Placeholder/Placeholder";
import { ProductsMap } from "@/libs/commerce/products";

import { simpleProductTeaserInputs } from "./SimpleProductTeaser.builder";

type SimpleProductTeaserProps = BuilderComponentProps<
  typeof simpleProductTeaserInputs
>;

const client = new QueryClient();

export function SimpleProductTeaserDynamicData({
  link,
  name,
  src,
  sku,
}: SimpleProductTeaserProps & { products: ProductsMap }) {
  const { __ } = useTranslations();
  const productsData = useProductsDynamicData({
    productsSkus: [sku?.options?.product].filter(Boolean),
  });

  const productData = productsData.products[sku?.options?.product]?.productData;

  if (!productData) {
    return (
      <Placeholder>
        Select proper product or fill custom title and image
      </Placeholder>
    );
  }

  return (
    <QueryClientProvider client={client}>
      <UISimpleProdutTeaser
        name={productData?.name || name || ""}
        src={productData?.image || src || ""}
        link={{
          href: link?.href || "/",
          text: link?.text || __("product.button.buynow"),
        }}
        alt={productData?.name || name || ""}
      />
    </QueryClientProvider>
  );
}

export function SimpleProductTeaserAuthorView(
  props: SimpleProductTeaserProps & { products: ProductsMap }
) {
  return (
    <QueryClientProvider client={client}>
      <SimpleProductTeaserDynamicData {...props} />
    </QueryClientProvider>
  );
}
